import { compose } from "redux";
import React, { PureComponent } from "react";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

class WorkScheduleReportFlexDays extends PureComponent {
  render() {
    const { count, classes } = this.props;

    if (!count) return null;

    return (
      <Typography className={classes.root}>{"F".repeat(count)}</Typography>
    );
  }
}

WorkScheduleReportFlexDays.defaultProps = {
  count: 0,
};

const styles = theme => ({
  root: {
    fontSize: "0.6rem",
    lineHeight: "0.6rem",
    position: "absolute",
    left: theme.spacing(0.25),
    bottom: theme.spacing(0.25),
    letterSpacing: theme.spacing(0.5),
    color: theme.altus.calendar.contrastColor,
  },
});

export default compose(withStyles(styles))(WorkScheduleReportFlexDays);
